import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import { StyledWrapper } from '../styled';
import { fontDisplay, fontUi, viewMoreLink } from '../../theme/typography';

export const StyledWrapperContainer = styled(StyledWrapper)`
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
`;

export const StyledLoader = styled(Loader)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledContainerLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: ${({ theme }) => theme.page};
`;

export const StyledHero = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 112px;
  margin-bottom: 24px;
  padding: 22px 28px;
  border-radius: ${({ theme }) => theme.cardRadius};
  background: #000;
  overflow: visible;
  box-sizing: border-box;

  @media only screen and (max-width: 768px) {
    min-height: 96px;
    padding: 16px 18px;
    flex-wrap: wrap;
  }
`;

export const StyledHeroPhoto = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.cardRadius};
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.65;
  }
`;

export const StyledHeroCopy = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  h1 {
    ${fontDisplay};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 32px;
    letter-spacing: -0.02em;
    @media only screen and (max-width: 768px) {
      font-size: 24px;
    }
    svg {
      flex-shrink: 0;
    }
  }

  p {
    ${fontUi};
    margin: 0;
    color: rgba(255, 255, 255, 0.55);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
`;

export const StyledLeagueGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 25px;
  align-items: start;
  width: 100%;

  @media only screen and (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

const spanColumn = (desktop) => `
  min-width: 0;
  grid-column: span ${desktop};
  @media only screen and (max-width: 1199px) {
    grid-column: 1 / -1;
  }
`;

export const StyledTableColumn = styled.div`
  ${spanColumn(8)};
`;

export const StyledFixturesColumn = styled.div`
  ${spanColumn(4)};
`;

export const StyledFormColumn = styled.div`
  ${spanColumn(4)};
  display: flex;
  flex-direction: column;

  > div:first-of-type {
    margin-bottom: 10px;
  }
`;

export const StyledStatsColumn = styled.div`
  ${spanColumn(8)};
  display: flex;
  flex-direction: column;

  > div:first-of-type {
    margin-bottom: 10px;
  }
`;

export const StyledAllScorersLink = styled(Link)`
  ${viewMoreLink};
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledStandingsCard = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 8px 16px 10px;
  box-sizing: border-box;
`;

export const StyledPanelCard = styled(StyledStandingsCard)`
  h1,
  h2,
  h3,
  h4 {
    display: none;
  }
`;
